<template>
  <div class="ordina">
    <v-row>
      <v-btn
        class="white--text ordina-button"
        tile
        block
        large
        elevation="0"
        x-large
        color="#000000"
        :class="{ flashing: flashing, ordina: !flashing }"
        v-on:click="make_order"
      >
        {{ ordina }}
      </v-btn>
    </v-row>
    <v-row class="row_double_button">
      <v-btn
        class="#484A4B--text cart"
        tile
        large
        elevation="0"
        x-large
        color="#DDE2E6"
        @click="go_to_cart"
      >
        <v-icon left dark> mdi-cart-outline </v-icon>
        {{ vedicarrello }} {{cart_number}}
      </v-btn>
      <p class="div_min_width_20"></p>
      <v-btn
        class="#484A4B--text ricambi"
        tile
        large
        elevation="0"
        x-large
        color="#DDE2E6"
        @click="show()"
      >
        <v-icon left dark> mdi-cards-outline </v-icon>
        {{ vediricambi }}
      </v-btn>
    </v-row>
    <modal name="my-first-modal"    :width="915">
      <div class="element-replacement">
        <div class="button_close_modal_ricambi">
          <div class="close_btn_css" @click="hide()" ></div>
          <div class="hide-button hide-button-replacement " large color="primary" @click="hide()">
            
          </div>
        </div>
               <p class="ricambi_title_p"> <strong> {{ ricambi_title }} </strong> </p>
        <div class="img-buttons">
          <img :src="url + '/risorse/ricambi/' + IMAGE"   onerror="this.src='https://vistosi.it/risorse/prodotto/IMGNOTFOUND.jpg'" style="max-width: 254px;" />
          <!-- div button ricambi --> 
          <div class="buttons_ricambi">
                  <div class ="buttons_only">
                      
                             <p class="normal seleziona_il_ricambio articolo_grigetto_maiuscolo"> {{ ricambi_info}} </p>
                            <div   class="text_align_left"   v-for="list in ricambi"   :key="list.CODICE_FINITO" >
                                    <!-- v button -->
                                    <v-btn   class="button_ricambi numero_vetro_button  "   large   color="primary"   @click="add_to_cart(list.CODICE_COMPONENTE,list.Codice_alternativo_att , list)" >
                                   <span class="numero_vetro_list">{{ list.NUMERO_VETRO }}</span>    {{ list.DITA}} 
                                    </v-btn>
                            </div>
                  </div>



                               <div v-if="hide_cordice_articolo" class="CODICE_ARTICOLO">  
                                 <p class="articolo_grigetto_maiuscolo">  {{codice_articolo_title }}:  </p> 
                                 <p  class="articolo_grigetto_maiuscolo_strong"> {{ codice_alt }} </p> 
                               </div>
<!-- if ordina ricambi -->
        <div v-if="hide_cordice_articolo" class="ordina_ricambi">
          
                <div class="quantita_dat_ordina_ricambi ">
                    <p class="articolo_grigetto_maiuscolo">  {{quantita_ricambi}}  </p>
             <div class="quantity_toggle">
        <button class="quantity_toggle_button" @click="decrement()">
          &mdash;
        </button>
        <input
          class="quantity_toggle_input"
          type="text"
          :value="quantity"
          readonly
        />
        <button class="quantity_toggle_button" @click="increment()">
          &#xff0b;
        </button>
      </div>
          </div>
    <div class="disponibilita_ordina_ricambi">
              <p class="articolo_grigetto_maiuscolo">  {{disponibilita}}  </p>
              <p class="no_space articolo_grigetto_maiuscolo_strong">{{disponibilita_articolo}}  </p>
          </div>
    <div class="disponibilita_dat_ordina_ricambi">
              <p class="articolo_grigetto_maiuscolo" >  {{data_disponibilita}}  </p>
              <p class="no_space articolo_grigetto_maiuscolo_strong">  {{disponibilita_articolo_data}}* </p>
          </div>
          <div class="prezzo_ordina_ricambi ">
              <p class="articolo_grigetto_maiuscolo">  {{PREZZO}}  </p>
              <p class="no_space articolo_grigetto_maiuscolo_strong" >  {{PREZZO_ARTICOLO}} {{ valuta }}  </p>
          </div>
      
      
     
   <div class="ordina_dat_ordina_ricambi">
       <!-- <p> <strong> {{ORDINA_NAME_TITLE}} </strong> </p> -->
        <v-btn
              class="button_ricambi button_ricambi_ordina"
              large
              color="primary"
              @click="ordina_ricambi()"
            >
        {{ORDINA_NAME_TITLE}}
         
                     </v-btn>
           </div>
        </div>
<!-- // ordina ricambi -->
                           
          </div>
          <!-- end div button ricambi --> 
        </div>


      <!-- ordina ricambi end -->
      <div class="alert-disponibilità">
      <p class="small"> {{ alert }} </p>
      </div>
      <!-- alert disponibility -->
      </div>
    </modal>
  </div>
</template>
<script>
import checkLanguage from "./../classes/class_check_language";
import order from "./../classes/class_order";
import is_localhost from "../classes/class_is_localhost";
import get_json_product from "../classes/class_get_json_product";

export default {
  name: "ordina",
  data: () => ({
    ordinando: false,
    flashing: false,
    flashing_button:  false,
    url: "",
    ricambi: [],
    IMAGE: '',
    prezzi_ricambi: [],
    codice_articolo : '',
    VALUTA : '€',
    PREZZO_ARTICOLO : '',
    disponibilita_articolo : '',
    disponibilita_array: [],
    disponibilita_articolo_data:'',
    quantity: 1,
    hide_cordice_articolo: false,
    count_prodotto:'',
    count_prodotto_string:'',
    codice_alt:'',
  }),
  mounted() {
    let ur = new is_localhost();

    this.url = ur.return_url_website();
    // controllo se inglese
    let i = new checkLanguage();
    if (!i.is_italian()) {
      this.$store.commit("change_language", { language: "en" });
    }
    this.$store.subscribe((mutation) => {
      if (mutation.type == "set_ordinando") {
        this.ordinando = this.$store.state.product_store.ORDINANDO;
      }
      if (mutation.type == "set_flashing") {
        this.flashing = this.$store.state.product_store.FLASHING;
      }
    });
    this.count_prodotto = window.descrizione.count;
             this.$store.commit("change_cart_count", { count: this.count_prodotto });
  },
  computed: {
    cart_number(){
      let c = this.$store.state.cart.count;
      if (c > 0) {
        return '('+c+')';
      }else{
        return '';
      }
    },
    ordina() {
      let language = this.$store.state.product.language;
      if (!this.flashing) {
        return this.$store.state[language].ordina;
      } else {
        if (!this.ordinando) {
          return this.$store.state[language].ordineinserito;
        } else {
          return this.$store.state[language].ordinando;
        }
      }
    },

    vedicarrello() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].vedicarrello;
    },
    wid() {
      return this.$store.state.product.wid;
    },
    pid() {
      return this.$store.state.product.id;
    },
    vediricambi() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].vediricambi;
    },
     codice_articolo_title() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].codice_articolo;
    },
         PREZZO() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].PREZZO;
    },
             disponibilita() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].disponibilita;
    },
              data_disponibilita() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].data_prox_disponibilita;
    },
               ordina_button() {
      let language = this.$store.state.product.language;
      
      return this.$store.state[language].ordina;
    },
               quantita_ricambi() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].quantita_ricambi;
    },
                alert() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].alert;
    },
                ricambi_info() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].ricambi_info;
    },
                   ricambi_title() {
      let language = this.$store.state.product.language;
      return this.$store.state[language].ricambi_title;
    },
                   ORDINA_NAME_TITLE() {
      let language = this.$store.state.product.language;
      if (this.flashing_button) {
        return this.$store.state[language].ORDINA_NAME_TITLE_LOADING;
      } else {
      return this.$store.state[language].ORDINA_NAME_TITLE;
        }
      
    },
        valuta(){
            let valuta = '€';
           if (this.$store.state.product.codice_listino == '6'){
                valuta = 'c$';
             }
                 if (this.$store.state.product.codice_listino == '7'){
                valuta = '$';
             }
            return valuta;
        }
  },
  methods: {
    ordina_ricambi() {
      this.$store.commit("is_loading_order", { is_loading: true });
      let CU          = this.$store.state.product_store.CODICE_UNIVOCO;
      let CR          = this.codice_articolo;
      let PRODID      = window.descrizione.descrizione.WCID;
      let PREZZO      = this.PREZZO_ARTICOLO;
      let QUANTITY    = this.quantity;
      let TIPOLOGIA   = this.$store.state.products.SORGENTE[0].tipologia;
      this.flashing_button = true;
      let O = new order();
      O.get_product_ricambi_id_from_unique_code(CU         ,CR         ,PRODID     ,PREZZO     ,QUANTITY   ,TIPOLOGIA  ,this.$store,this.flashing_button)

    },
 

    add_to_cart(code, codice_alt) {
      this.hide_cordice_articolo = true;
      this.codice_articolo = code;
      this.codice_alt = codice_alt;
      try{
        if (window.innerWidth<1020){
            let modal =   document.getElementsByClassName('vm--modal');
            modal[0].style.top = '60px';
        }
      this.prezzi_ricambi.forEach(element => {
        if ( element.Codice_articolo == code)
        this.PREZZO_ARTICOLO =  element.prezzo;
      });
           } catch (error) {
            console.info(error);
        }
        try{
      this.disponibilita_array.forEach(element => {
        if ( element.Articolo == code)
        this.disponibilita_articolo =  element.Magazzino;
        this.disponibilita_articolo_data =  element.Data_prossima_disponibilita;
      });
           } catch (error) {
            console.info(error);
        }
    },

    show() {
      this.hide_cordice_articolo = false;
      let r = document.querySelectorAll(".sezione-download");
   try{
       r[0].classList.add("zindex_down");
           let b = document.querySelectorAll("body");
       b[0].classList.add("stop-scrolling");
       }catch(e){
                console.info(e)
            }
      // cerca immagine e lista elementi code
      let cu = this.$store.state.product_store.CODICE_UNIVOCO;
      let y = new get_json_product();
      let cl = this.$store.state.product.codice_listino;
      y.GET_IMG_RICAMBIO_PROMISE(cu, cl).then((data) => {
        this.ricambi = data.data.pulsanti;
        this.IMAGE = data.data.pulsanti[0].IMAGE;
        this.prezzi_ricambi = data.data.prezzi;
        this.disponibilita_array = data.data.disponibilita;
      this.$modal.show("my-first-modal");
      this.modal_show = true;
      });
    },
    hide() {
      this.modal_show = false;
      this.$modal.hide("my-first-modal");
      this.codice_articolo = '';
      this.PREZZO_ARTICOLO = '';
      this.disponibilita_articolo = '';
      this.disponibilita_articolo_data = '';
      this.quantity = 1;
            let r = document.querySelectorAll(".sezione-download");
   try{
       r[0].classList.remove("zindex_down");
     let b = document.querySelectorAll("body");
       b[0].classList.remove("stop-scrolling");
     }catch(e){
                console.info(e)
            }  
    },
    go_to_cart() {
      let i = new checkLanguage();
      if (!i.is_italian()) {
        window.location.href = '/?p=10631';
      } else {
        window.location.href = window.descrizione.cart_url;
      }
    },
    make_order() {
          this.$store.commit("is_loading_order", { is_loading: true });
      let O = new order();
      this.$store.commit("set_ordinando", true);
      this.$store.commit("set_ordinando", true);
      this.$store.commit("set_flashing", true);
      let CODICE_UNIVOCO = this.$store.state.product_store.CODICE_UNIVOCO;
      let PRODID = window.descrizione.descrizione.WCID;
      let PREZZO = this.$store.state.product_store.PREZZO;
      O.get_product_id_from_unique_code(
        CODICE_UNIVOCO,
        PRODID,
        PREZZO,
        this.$store
      );
   
   },

  increment() {
      this.quantity++;
      this.$store.commit('setta_quantita_ricambi_richiesta', this.quantity);
    },
    decrement() {
      if (this.quantity === 1) {
        this.nothing = 1;
      } else {
        this.quantity--;
      }
       this.$store.commit('setta_quantita_ricambi_richiesta', this.quantity);
    },
  },
};
</script>
<style scoped>
.ordina {
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}
.flashing {
  background-color: rgb(18, 19, 18) !important;
  -webkit-transition: background-color 500ms linear;
  -ms-transition: background-color 500ms linear;
  transition: background-color 500ms linear;
}
.ordina button.ordina-button:hover,
.ordina button.ordina-button .v-btn__content:hover {
  color: black !important;
  background-color: white !important;
}
.ordina .row:hover {
  color: black !important;
  background-color: white !important;
}
.element-replacement {
  display: flex;
  flex-direction: column;
}
.img-buttons, .ordina_ricambi {
  display: flex;
  flex-direction: row;
}
.ordina_ricambi{
  justify-content: unset;
}
.ordina_ricambi .no_space{
  padding-bottom: 0px !important;
  margin-bottom: 15px !important;
  margin-top:4px !important;
}
.buttons_ricambi, .prezzo_ordina_ricambi, .disponibilita_ordina_ricambi, .disponibilita_dat_ordina_ricambi {
  display: flex;
  flex-direction: column;
}
.hide-button-replacement {
      text-align: end;
}
.quantity_toggle_button {
  padding: 0.5rem;
  background: #ffffff;
  color: #888;
  font-size: 1rem;
  cursor: pointer;
}

.quantity_toggle_input {
  border-top: none !important;
  border-bottom: none !important;
  width: 2.5rem;
  text-align: center;
  padding: 0 0.5rem;
  background: #ffffff;
  border-left: solid;
  border-left-width: 0.1rem;
  border-left-color: rgb(204, 204, 204);
  border-right: solid;
  border-right-width: 0.1rem;
  border-right-color: rgb(204, 204, 204);
}
.quantity_toggle_button {
  padding: 0.5rem;
  background: #ffffff;
  color: #888;
  font-size: 1rem;
  cursor: pointer;
}
.quantity_toggle {
  display: flex !important;
  flex-direction: row !important;

  border: 0.5px;
  border-color: #888;
  border-style: solid;
  width:109px !important;

  margin: unset;
  padding: unset;


}
.quantita_dat_ordina_ricambi{
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:baseline;
      margin-bottom: 15px;
}
.small{
  font-size:10px;
  margin:10px;
}
.buttons_ricambi{
      flex-grow: 2;
      justify-content: unset;
}
.buttons_only{
  display:flex;
  flex-direction:column;
}
.numero_vetro_button{
  width:88%;
  margin-bottom:5px;
}
.button_close_modal_ricambi{
      justify-content: flex-end;
    display: flex;
}
.button_close_modal_ricambi div{
        min-width: 35px;
        min-height: 35px;
        padding:15px;
        cursor: pointer;
}

.button_ricambi{
  border-radius: 0px;
    outline: none;
}
.ordina_ricambi{
  display: flex;
    flex-direction: column;
}
.img-buttons img{
  height:fit-content;
}
button.button_ricambi.numero_vetro_button {
    background-color: #f5f5f5 !important;
    color: black;
    font-weight: 700;
    border-radius: 0px;
    border: 1px solid #f5f5f5 !important;
}


.ricambi_title_p{
  text-align: left;
    font-size: 33px;
    margin-left: 25px;
}
.articolo_grigetto_maiuscolo{
      font-size: 14px;
    font-weight: 400;
    color: #001717;
    text-transform: uppercase;
    margin-bottom: 0px ;
    text-align:left !important;
}
.articolo_grigetto_maiuscolo_strong{
  font-weight: 700;
  color:black;
    text-align:left;
    font-size: 14px;
}
.button_ricambi_ordina{
  width:88%;
  text-align:left;
}
.close_btn_css {
  position: absolute;
  right: 22px;
  top: 22px;
  width: 22px;
  height: 22px;
  opacity: 0.3;
}
.close_btn_css:hover {
  opacity: 1;
}
.close_btn_css:before, .close_btn_css:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 23px;
  width: 2px;
  background-color: #333;
}
.close_btn_css:before {
  transform: rotate(45deg);
}
.close_btn_css:after {
  transform: rotate(-45deg);
}
.text_align_left, .ordina_dat_ordina_ricambi{
  text-align:left;
}
.quantita_dat_ordina_ricambi  .quantity_toggle{
  height:40px;
}
.quantita_dat_ordina_ricambi .quantity_toggle_button{
  font-size:13px;
}
.seleziona_il_ricambio{
  margin-bottom:15px;
}
.numero_vetro_list{
  border: 1px solid black;
    min-width: 23px;
    border-radius: 15px;
    margin-right: 10px;
}
</style>